import { render, staticRenderFns } from "./AuthOrDivider.vue?vue&type=template&id=2bc0365f&scoped=true&"
import script from "./AuthOrDivider.vue?vue&type=script&lang=js&"
export * from "./AuthOrDivider.vue?vue&type=script&lang=js&"
import style0 from "./AuthOrDivider.vue?vue&type=style&index=0&id=2bc0365f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc0365f",
  null
  
)

export default component.exports